import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import { Box } from '@mui/material';
import { useUser } from 'contexts/userContext';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import { FC } from 'react';

import Sidebar from 'components/Sidebar';

const ResponsiveSidebarLayout: FC<{ children: any }> = props => {
  const { user } = useUser();

  const isAdmin = user?.role?.name === 'ADMIN';
  const isHOD = user?.role?.name === 'HOD';

  const tabs: {
    key: string;
    label: string;
    icon: React.ReactNode;
    route: string;
  }[] = [];

  if (!!user?.reportees?.length) {
    tabs.push({
      key: 'dashboard',
      label: 'Dashboard',
      icon: <SpaceDashboardIcon fontSize="small" />,
      route: '/',
    });
  }

  tabs.push({
    key: 'self',
    label: 'Self',
    icon: <HowToRegIcon fontSize="small" />,
    route: '/self',
  });

  if (!!user?.reportees?.length) {
    tabs.push({
      key: 'team',
      label: 'Teams',
      icon: <PeopleAltIcon fontSize="small" />,
      route: '/team',
    });
  }

  if (isHOD) {
    tabs.push({
      key: 'hod-reports',
      label: 'Department Reports',
      icon: <FileDownloadIcon fontSize="small" />,
      route: '/hod-reports',
    });
  }

  if (isAdmin) {
    tabs.push(
      {
        key: 'allEmployees',
        icon: <GroupsIcon fontSize="small" />,
        label: 'Employees',
        route: '/admin-users',
      },
      {
        key: 'addEmployee',
        label: 'Add / Update',
        icon: <GroupAddIcon fontSize="small" />,
        route: '/users/create-user',
      },
      {
        key: 'deleteEmployee',
        label: 'Remove / Reassign',
        icon: <GroupRemoveIcon fontSize="small" />,
        route: '/users/remove-user',
      },
      {
        key: 'downloadReport',
        label: 'Reports',
        icon: <SaveAltIcon fontSize="small" />,
        route: '/admin-reports',
      }
    );
  }
  tabs.push({
    key: 'year',
    label: 'Year Settings',
    icon: <CalendarMonthIcon fontSize="small" />,
    route: '/year-settings',
  });

  const renderContent = () => {
    return (
      <>
        <Sidebar tabs={tabs} />
        <Box
          component="main"
          sx={{
            px: 2,
            pt: 1,
            width: '100%',
            height: '100%',
          }}
        >
          {props.children}
        </Box>
      </>
    );
  };

  return <Box sx={{ display: 'flex' }}>{renderContent()}</Box>;
};

export default ResponsiveSidebarLayout;
